import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet from 'src/constants/stylesheet';
import ViewMonitor from 'src/utils/ViewMonitor';

const useStyles = makeStyles(() =>
    createStyles({
        twoColumnTextContainer: {
            width: `100%`,
            display: 'flex',
            flexWrap: 'wrap',
            [mediaQueries.Mobile]: {
                paddingBottom: spacing.Gutter.Mobile/ 2,
            },
            [mediaQueries.Tablet]: {
                paddingBottom: spacing.Gutter.Tablet/ 2,
            },
            [mediaQueries.Laptop]: {
                paddingBottom: spacing.Gutter.Laptop/ 2,
            },
            [mediaQueries.Desktop]: {
                paddingBottom: spacing.Gutter.Desktop/ 2,
            },
            [mediaQueries.BigDesktop]: {
                width: `${2 / 3 * 100}%`,
                marginLeft: 'auto',
                paddingBottom: spacing.Gutter.BigDesktop/ 2,
            }
        },
        twoColumnTextCoolumn: {
            [mediaQueries.Mobile]: {
                width: `100%`,
                paddingLeft: spacing.GutterGrid.Mobile / 2,
                paddingRight: spacing.GutterGrid.Mobile / 2,
            },
            [mediaQueries.Tablet]: {
                width: `50%`,
                paddingLeft: spacing.GutterGrid.Tablet / 2,
                paddingRight: spacing.GutterGrid.Tablet / 2,
            },
            [mediaQueries.Laptop]: {
                width: `50%`,
                paddingLeft: spacing.GutterGrid.Laptop / 2,
                paddingRight: spacing.GutterGrid.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                width: `50%`,
                paddingLeft: spacing.GutterGrid.Desktop / 2,
                paddingRight: spacing.GutterGrid.Desktop / 2,
            },
            [mediaQueries.BigDesktop]: {
                width: `50%`,
                paddingLeft: spacing.GutterGrid.BigDesktop / 2,
                paddingRight: spacing.GutterGrid.BigDesktop / 2,
            }
        },
        readMoreContent: {
            width: `100%`,
            [mediaQueries.Mobile]: {
                paddingLeft: spacing.GutterGrid.Mobile / 2,
                paddingRight: spacing.GutterGrid.Mobile / 2,
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.GutterGrid.Tablet / 2,
                paddingRight: spacing.GutterGrid.Tablet / 2,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.GutterGrid.Laptop / 2,
                paddingRight: spacing.GutterGrid.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.GutterGrid.Desktop / 2,
                paddingRight: spacing.GutterGrid.Desktop / 2,
            },
            [mediaQueries.BigDesktop]: {
                paddingLeft: spacing.GutterGrid.BigDesktop / 2,
                paddingRight: spacing.GutterGrid.BigDesktop / 2,
            }
        },
        hideTextOne: {
            ...stylesheet.Hide,
            transitionDelay: '100ms',
            [mediaQueries.Mobile]: {
                paddingBottom: spacing.GutterGrid.Mobile,
            },
        },
        hideTextTwo: {
            ...stylesheet.Hide,
            transitionDelay: '200ms'
        },
        show: {
            ...stylesheet.Show
        }
    }));

export type PanelTwoColumnsProps = PanelTwoColumnsTextDto;

type Props = PanelTwoColumnsProps;

const PanelTwoColumnsText: FC<Props> = ({ children, TextOne, TextTwo }) => {
    const cls = useStyles();

    return (
        <div className={cls.twoColumnTextContainer}>
            <ViewMonitor once={true}>{(intersect) =>
                <div
                    className={classNames(cls.twoColumnTextCoolumn, cls.hideTextOne, intersect && cls.show)}
                    dangerouslySetInnerHTML={{ __html: TextOne }}
                />}
            </ViewMonitor>
            <ViewMonitor once={true}>{(intersect) =>
                <div
                    className={classNames(cls.twoColumnTextCoolumn, cls.hideTextTwo, intersect && cls.show)}
                    dangerouslySetInnerHTML={{ __html: TextTwo }}
                />}
            </ViewMonitor>
            <div className={cls.readMoreContent}>
                {children}
            </div>
        </div>
    );
};

export default PanelTwoColumnsText;



// WEBPACK FOOTER //
// ./src/Components/Panels/PanelTwoColumnsText.tsx